// extracted by mini-css-extract-plugin
module.exports = {"bottomNavbarWrapper":"vOls8PN1AYa814at4LBXi"};